import Cookies from 'js-cookie';

document.querySelectorAll('.popup').forEach(($popup) => {
  const cookieName = 'bawu-popup';
  const sessionCookie = Cookies.get(cookieName) === 'true';
  const $section = $popup.closest('.page__section');

  if (!sessionCookie) {
    Cookies.set(cookieName, true, { expires: 7 });
    $popup.classList.add('popup--active');
    $section.classList.add('page__section--popup-active');
  } else {
    $popup.classList.remove('popup--active');
    $section.classList.remove('page__section--popup-active');
  }
});
